// extracted by mini-css-extract-plugin
export default {"search":"Typehead_search__6V-rY","searchBar":"Typehead_searchBar__N3--v","searchTerm":"Typehead_searchTerm__E0v3A","iconButton":"Typehead_iconButton__A-NGc"};